import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/web/web/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/web/web/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/runner/work/web/web/node_modules/next/dist/client/app-dir/link.js");
